<nb-card class="grid">
  <nb-card-body>
    <ng2-smart-table
      [settings]="settings"
      [source]="source"
      (edit)="onEdit($event)"
      (userRowSelect)="onRowSelect($event)"
      (delete)="onDelete($event)"
      (custom)="custom.emit($event)"
    >
    </ng2-smart-table>
  </nb-card-body>
</nb-card>
